/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */

/**
 * Lab provider IDs used by Junction
 */
export type LabProvider = typeof LabProvider[keyof typeof LabProvider];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LabProvider = {
  quest: 'quest',
  labcorp: 'labcorp',
  bioreference: 'bioreference',
} as const;
